<template>
    <div class="toggle-switch" :class="{ 'toggle-switch--active': value }" @click="toggleSwitch">
        <input type="checkbox" :id="id" class="toggle-switch__checkbox" :checked="value" />
        <label :for="id" class="toggle-switch__label"></label>
    </div>
</template>
  
<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    methods: {
        toggleSwitch() {
            this.$emit('input', !this.value);
        },
    },
};
</script>
<style lang="scss" scoped>
.toggle-switch {
    position: relative;
    width: 35px;

    height: 24px;

    background-color: #ccc;
    border-radius: 20px;

    overflow: hidden;
}

.toggle-switch__checkbox {
    position: absolute;
    left: -9999px;
}


.toggle-switch__label {
    position: absolute;
    top: 2px;

    left: 2px;

    width: 19px;

    height: 19px;

    background-color: #fff;
    border-radius: 50%;
    transition: transform 0.3s ease;
    cursor: pointer;
}


.toggle-switch--active {
    background-color: #007bff;

}


.toggle-switch--active .toggle-switch__label {
    transform: translateX(12px);

}
</style>